import { Box, IconButton } from '@mui/material'
import React from 'react'
import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import InstagramIcon from '@mui/icons-material/Instagram'
import YouTubeIcon from '@mui/icons-material/YouTube'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import Envisioneer from '../../assets/svg/marks/primary/envisioneer.svg'

const SocialMedia = (props) => {
  return (
    <Box sx={{display: "flex", flexDirection: props.flexDirection, jusitfyContent: "center", alignItems: "center",}}>
      <IconButton aria-label="cadsoft" href="https://www.cadsoft.com/" target="_blank">
        <Box
          alt="Envisioneer Logomark"
          component="img"
          src={Envisioneer}
          sx={{width: 24, height: 24,}}
        />
      </IconButton>
      <IconButton aria-label="facebook" href="https://www.facebook.com/CadsoftCorporation" target="_blank">
        <FacebookIcon sx={{color: "#1674ea"}} />
      </IconButton>
      <IconButton aria-label="twitter" href="https://www.twitter.com/Cadsoft_Corp" target="_blank">
        <TwitterIcon sx={{color: "#1c9cea"}} />
      </IconButton>
      <IconButton aria-label="instagram" href="https://www.instagram.com/cadsoft_corp" target="_blank">
        <InstagramIcon sx={{color: "#db10a8"}} />
      </IconButton>
      <IconButton aria-label="youtube" href="https://www.youtube.com/user/Cadsoftcorp/" target="_blank">
        <YouTubeIcon sx={{color: "#f70000"}} />
      </IconButton>
      <IconButton aria-label="linkedin" href="https://www.linkedin.com/company/cadsoft-corporation/" target="_blank">
        <LinkedInIcon sx={{color: "#0077b0"}} />
      </IconButton>
    </Box>
  )
}

export default SocialMedia